import React from 'react'
import { useIntl } from 'react-intl'
import { Link, useHistory } from 'react-router-dom'
import { useCart } from 'lib/core/hooks/useCart'
import { MetaData } from 'components/MetaData'
import { FadeIn, Spinner, EmptyContainer, Button } from 'lib/ui/components'
import { List } from './components/List'
import { Totals } from './components/Totals'
import { Coupon } from './components/Coupon'
import { Actions } from 'components/Cart/components/Actions'
import { CartProvider } from 'components/Cart/components/CartProvider'

import {
  Section,
  Container,
  CartLayout,
  LinkWrapper
} from './components/Styled'

export const Cart = () => {
  const intl = useIntl()
  const { cart, count } = useCart()
  const history = useHistory()
  const isLoading = !cart?.data || cart?.isFirstLoad
  const title = intl.formatMessage({ id: 'cart.title' })

  return (
    <CartProvider>
      <>
        <MetaData
          title={title}
        />
        <Section>
          <Container>
            <h1>{title}</h1>
            {isLoading ? (
              <EmptyContainer>
                <Spinner />
              </EmptyContainer>
            ) : (
              <FadeIn>
                {count ? (
                  <CartLayout>
                    <div className='cart-main'>
                      <List />
                      <LinkWrapper>
                        <Link
                          to='/bladder-control'
                        >
                          Continue Shopping
                        </Link>
                      </LinkWrapper>
                    </div>
                    <div className='cart-aside'>
                      <Totals />
                      <Coupon />
                      <Actions />
                    </div>
                  </CartLayout>
                ) : (
                  <>
                    <p>{intl.formatMessage({ id: 'cart.emptyMessage' })}</p>
                    <Button
                      onClick={() => history.push('/bladder-control')}
                    >
                      Continue Shopping
                    </Button>
                  </>
                )}
              </FadeIn>
            )}
          </Container>
        </Section>
      </>
    </CartProvider>
  )
}
